// extracted by mini-css-extract-plugin
export var videoContainer = "_ix-0";
export var videoIframe = "_ix-3";
export var videoLink = "_ix-1";
export var videoOverlay = "_ix-4";
export var videoOverlayText = "_ix-5";
export var videoWrapper = "_ix-2";